import React from 'react';
import cx from 'classnames';
import useBuildVariantProps from '../../../../modules/theme/useBuildVariantProps';
import styles from './TableHeader.module.scss';
import type { TableHeaderProps } from './TableHeader.types';

const TableHeader = (props: TableHeaderProps) => {
  const {
    className,
    children,
    ...otherProps
  } = props;

  const variantProps = useBuildVariantProps(
    'table',
    {},
    {},
  );

  return (
    <thead className={cx(styles.tableHeader, className)} { ...otherProps } { ...variantProps }>
      {children}
    </thead>
  );
};
export default TableHeader;
